import {
    PencilAltIcon,
    CalendarIcon, MinusSmIcon, PlusSmIcon
} from '@heroicons/react/outline'
import { Disclosure } from '@headlessui/react'
import {  SparklesIcon } from '@heroicons/react/solid'
import Image from 'next/image'
import Link from 'next/link'
import { useEffect, useState } from 'react'
import { cloudfront } from "../../../config";
import bizStyles from '../../../styles/Business.module.css'
import Layout from '../../../components/Layouts/landingLayout'
import AlertTemplate from '../../../components/Notification'
import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import { useAuth, AuthProvider } from '../../../contexts/Auth'
import Meta from "../../../components/Meta"
import * as ga from '../../../lib/gtag'
import { useRouter } from 'next/router'
import BurnoutQuiz from '../../../components/Quiz/BurnoutGetStarted'

const faqs = [
    {
      question: "How many times a week will I meet with my coach?",
      answer:
        "Plans start with meetings once a week either over video chat or with a phone call.  Additional meetings are available with an upgraded plan",
    },
    {
        question: "How are coaches qualified?",
        answer:
          "All coaches have prior experience as life or executive coaches and have earned at least a master's degree in education. Most have earned a Ph.D in counseling or education",
      },
      {
        question: "How does burnout coaching work?",
        answer:
          `Clients meet with coaches to identify the sources of burnout then commit to actionable solutions through practicing mindfulness, learning greater self-awareness, and improving conflict resolution.  This may  
          include learning how different personalities are more susceptible to burnout or how subtle life changes can help alleviate burnout `,
      },
      {
        question: "What if I need to reschedule?",
        answer:
          "Clients can check-in with their coaches then reschedule based on their coach's schedule through their client dashboard",
      },
      {
        question: "How much does Plaza burnout coaching cost?",
        answer:
          "We charge between $600 - $900 per month depending on the package selected.  Ask your employer if you qualify for reimbursement for burnout coaching",
      },
      {
        question: "What if I have additional questions?",
        answer:
          "Use the chat in the bottom-right corner to ask additional questions",
      },
  ]
export default function Service() {

    
    
    return (
        <div className="relative overflow-hidden">
            <Meta
                title="Physician Burnout Coaching - Plaza"
                description="Plaza physician burnout coaching helps professionals build up their mental fitness with weekly, one-on-one coaching sessions with certified coaches "

            />

            <main>
                <section className="pt-10 bg-slate-200/50 -mt-0 sm:pt-10 lg:pt-0 lg:pb-14 lg:overflow-hidden mb-2 sm:mb-40 md:mb-40 lg:mb-0">
                    <div className="mx-auto max-w-7xl lg:px-8">
                        <div className="lg:grid lg:grid-cols-2 lg:gap-8">
                            <div className="mx-auto h-full max-w-md px-4 sm:max-w-2xl sm:px-6 sm:text-center lg:px-0 lg:text-left lg:flex lg:items-center">
                                <div className="lg:py-12">
                                    {/* <a
                      href="#"
                      className="inline-flex items-center text-white bg-black rounded-full p-1 pr-2 sm:text-base lg:text-sm xl:text-base hover:text-gray-200"
                    >
                      <span className="px-3 py-0.5 text-white text-xs font-semibold leading-5 uppercase tracking-wide bg-fuchsia-700 rounded-full">
                        Beta
                      </span>
                      <span className="ml-4 text-sm">We just launched!</span>
                      <ChevronRightIcon className="ml-2 w-5 h-5 text-gray-600" aria-hidden="true" />
                    </a> */}     <div className='mt-1'><span className='text-fuchsia-700 bg-fuchsia-100 px-2 py-1 rounded-lg'>New</span></div>
                                    <h1 className="mt-4 text-4xl tracking-tight font-extrabold mb-10 text-black sm:mt-5 sm:text-5xl lg:mt-2 xl:text-4xl">
                                        <span className="block ">Beat <span className="text-fuchsia-600"> physician burnout</span> and build up your</span>
                                        <span className="block "><span className="underline decoration-fuchsia-600 decoration-wavy decoration-4">mental fitness </span></span>
                                    </h1>
                                    <div className="blur-3xl  -ml-10  absolute h-32 w-32 -z-10 bg-fuchsia-500" />

                                    <p className="mt-3 text-base text-gray-700 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                                       Weekly calls with certified coaches to help alleviate burnout symptoms and manage stress as a physician

                                    </p>
                                    <div className="">
                                            <div className="w-full mt-8 mb-10 lg:mb-0 sm:w-1/2 mx-auto lg:mx-0 md:w-1/3">
                                                <a
                                                    href={"#bookDemo"}
                                                    className="block w-full py-3 text-center px-4 rounded-md hover:text-gray-900 shadow-lg shadow-fuchsia-500/50 bg-fuchsia-700 text-white font-medium hover:bg-fuchsia-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 focus:ring-offset-gray-900"
                                                >
                                                    Get Matched
                                                </a>
                                                <div className='flex justify-center items-center space-x-2 pt-5'>
                                    <div><SparklesIcon className='h-5 w-5 text-fuchsia-700' /></div>
                                    <p className='font-semibold'>Free Discovery Call</p>
                                </div>
                                            </div>
                                      
                                    </div>
                                </div>
                            </div>
                            <div className=" lg:pt-20 -mb-16 sm:-mb-48 lg:m-0 lg:relative">

                                <div className="blur-3xl mt-20 -ml-10 right-0 absolute h-32 w-32 -z-10 bg-fuchsia-500" />
                                <div className='my-auto mx-auto'>
                                <svg
          className=" invisible sm:visible absolute mx-auto pl-20 -z-10 transform  -translate-y-1/2"
          width={404}
          height={784}
          fill="none"
          viewBox="0 0 404 784"
          aria-hidden="true"
        >
          <defs>
            <pattern
              id="b1e6e422-73f8-40a6-b5d9-c8586e37e0e7"
              x={0}
              y={0}
              width={20}
              height={20}
              patternUnits="userSpaceOnUse"
            >
              <rect x={0} y={0} width={4} height={4} className="text-gray-300" fill="currentColor" />
            </pattern>
          </defs>
          <rect width={404} height={784} fill="url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)" />
        </svg>
                                <div className='flex flex-row justify-center space-y-1 mx-auto sm:mx-0'>
                                        <div className="blur-3xl  -ml-10 flex flex-row   absolute h-32 w-32 -z-10 bg-fuchsia-500"/>
                                        <div className='w-60 h-60 mr-3 -mb-5 overflow-hidden'>
                                        <video autoPlay loop muted className='rounded-xl w-30 h-32 object-cover object-top shadow-lg'>
                                        <source src={`${cloudfront}/media/stock_videos/video-chat-woman-talk.mp4`} type="video/mp4" />
                                        </video>
                
                                        </div>
                                        <div className='w-60 h-60 mb-3 mr-3 sm:pt-32'>
                                        <video autoPlay loop muted className='rounded-xl w-30 h-32 object-cover shadow-lg' >
                                        <source src={`${cloudfront}/media/stock_videos/video-chat-manager.mp4`} type="video/mp4" />
                                        </video>

                                        </div>
                                </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                {/* More main page content here... */}
                <section className="relative  pt-16 pb-32 overflow-hidden">
                    <div className="">
                        <div className="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
                            <div className="px-4 max-w-xl mx-auto sm:px-6 lg:py-32 lg:max-w-none lg:mx-0 lg:px-0 lg:col-start-2">
                                <div>
                                    <div className='z-20 relative'>
                                        <span className="h-12 w-12 rounded-md flex items-center justify-center bg-fuchsia-700">
                                            <CalendarIcon className="h-6 w-6 text-white" aria-hidden="true" />
                                        </span>
                                    </div>
                                    <div className="mt-6 z-20 relative">
                                        <h2 className="text-3xl font-extrabold tracking-tight text-gray-900">
                                            Who is this for?
                                        </h2>
                                        <p className="mt-4 text-lg text-gray-500">
                                          You&apos;re a physician dealing with a variety of burnout symptoms such as <span className="underline decoration-fuchsia-600 decoration-wavy decoration-2">fatigue, cynicism, and irritability. </span> 
                                          You&apos;re interested in help from a vetted and certified coach but don&apos;t know where to start.  
                                          With some coaches willing to overcharge for packages without providing value, you want a <span className="underline decoration-fuchsia-600 decoration-wavy decoration-2">fairly priced and 
                                          flexible service</span>
                                        </p>

                                    </div>
                                </div>
                            </div>
                            <div className="mt-12 sm:mt-16 lg:mt-0 lg:col-start-1 flex items-center  ">
                                <div className="pl-4 -mr-48 sm:pl-6 md:mr-16 lg:px-0 my-auto img-cont z-10" >
                                    <Image
                                        className={bizStyles.editorMockup }
                                        src={`${cloudfront}/static/burnout_listings.png`}
                                        width={1474}
                                        height={1005}
                                        objectFit={"contain"}
                                        alt="Plaza for video consultations"

                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="relative mt-24">
                        <div className="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
                            <div className="px-4 max-w-xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0">
                                <div>
                                    <div>
                                        <span className="h-12 w-12 rounded-md flex items-center justify-center bg-fuchsia-700">
                                            <PencilAltIcon className="h-6 w-6 text-white" aria-hidden="true" />
                                        </span>
                                    </div>
                                    <div className="mt-6 mr-10">
                                        {/* <h2 className="text-3xl font-extrabold tracking-tight text-gray-900">
                            Better understand your customers
                        </h2> */}
                                        <h2 className="text-3xl font-extrabold tracking-tight text-gray-900">
                                            How it Works
                                        </h2>
                                        <p className="mt-4 text-lg text-gray-500 relative z-20">After taking a quiz to determine your current circumstances, 
                                            we&apos;ll match you with a coach for a  complimentary<span className="underline decoration-fuchsia-600 decoration-wavy decoration-2"> discovery call </span>that fits your schedule. Afterwards you&apos;ll meet with 
                                            your coach once a week to practice<span className="underline decoration-fuchsia-600 decoration-wavy decoration-2"> identifying, managing, and alleviating</span> burnout.   
                                        </p>
                                        <div className="mt-6"> 
                                            <a
                                                href="#bookDemo"
                                                className="inline-flex px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-fuchsia-700 hover:text-gray-900 hover:bg-fuchsia-800"
                                            >
                                                Get started
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="mt-8 border-t border-gray-200 pt-6">
                    <blockquote>
                        <div>
                        <p className="text-base text-gray-500">
         
                        </p>
                        </div>
                        <footer className="mt-3">
                        <div className="flex items-center space-x-3">
                            <div className="flex-shrink-0">
                            <img
                                className="h-6 w-6 rounded-full"
                                src="https://images.unsplash.com/photo-1509783236416-c9ad59bae472?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=1024&h=1024&q=80"
                                alt=""
                            />
                            </div>
                            <div className="text-base font-medium text-gray-700">Marcia Hill, Digital Marketing Manager</div>
                        </div>
                        </footer>
                    </blockquote>
                    </div> */}
                            </div>
                            <div className="mt-32 sm:mt-16 lg:mt-0 flex items-center ">
                                <div className="pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 img-cont" >
                                    <Image
                                       className='scale-150'
                                        src={`${cloudfront}/static/listing_shadow.png`}
                                        width={1600}
                                        height={700}
                                        objectFit={"contain"}
                                        alt="Plaza for video consultations"

                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="lg:mx-auto mt-24 lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
                            <div className="px-4 max-w-xl mx-auto sm:px-6 lg:py-32 lg:max-w-none lg:mx-0 lg:px-0 lg:col-start-2">
                                <div>
                                    <div className='z-20 relative'>
                                        <span className="h-12 w-12 rounded-md flex items-center justify-center bg-fuchsia-700">
                                            <CalendarIcon className="h-6 w-6 text-white" aria-hidden="true" />
                                        </span>
                                    </div>
                                    <div className="mt-6 z-20 relative">
                                        <h2 className="text-3xl font-extrabold tracking-tight text-gray-900">
                                            Flexibility in mind
                                        </h2>
                                        <p className="mt-4 text-lg text-gray-500">
                                            Whether you prefer video chat or a phone call, we can conform to your platform of choice.
                                            Some prefer video chat to meet their coach face-to-face and visualize goals while others prefer 
                                            a simple phone call to prevent additional Zoom fatigue

                                        </p>

                                    </div>
                                </div>
                            </div>
                            <div className="mt-12 sm:mt-16 lg:mt-0 lg:col-start-1 flex items-center  ">
                                <div className="pl-4 -mr-48 sm:pl-6 md:mr-16 lg:px-0 my-auto img-cont z-10" >
                                    <Image
                                        className={bizStyles.editorMockup }
                                        src={`${cloudfront}/static/burnout_coach.png`}
                                        width={1474}
                                        height={1005}
                                        objectFit={"cover"}
                                        alt="Plaza for video consultations"

                                    />
                                </div>
                            </div>
                        </div>
             

                </section>



    <div className="bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="relative overflow-hidden bg-gray-900 px-6 py-20 shadow-xl sm:rounded-3xl sm:px-10 sm:py-24 md:px-12 lg:px-20">
          <img
            className="absolute inset-0 h-full w-full object-cover brightness-150 saturate-0"
            src="https://images.unsplash.com/photo-1601381718415-a05fb0a261f3?ixid=MXwxMjA3fDB8MHxwcm9maWxlLXBhZ2V8ODl8fHxlbnwwfHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1216&q=80"
            alt=""
          />
          <div className="absolute inset-0 bg-gray-900/90 mix-blend-multiply" />
          <div className="absolute -left-80 -top-56 transform-gpu blur-3xl" aria-hidden="true">
            <div
              className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-r from-[#ff4694] to-[#776fff] opacity-[0.45]"
              style={{
                clipPath:
                  'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
              }}
            />
          </div>
          <div
            className="hidden md:absolute md:bottom-16 md:left-[50rem] md:block md:transform-gpu md:blur-3xl"
            aria-hidden="true"
          >
            <div
              className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-r from-[#ff4694] to-[#776fff] opacity-25"
              style={{
                clipPath:
                  'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
              }}
            />
          </div>
          <div className="relative mx-auto max-w-2xl lg:mx-0">
          <Image
          height={100}
          width={200}
          objectFit='co'
          className="h-12 self-start" src={`${cloudfront}/static/journeyapps-logo-dark-bg.svg`} alt=""
          
          />
            <figure>
              <blockquote className="mt-6 text-lg font-semibold text-white sm:text-xl sm:leading-8">
                <p>
                “Lav helped me manage a high amount of stress as a result of an overwhelming workload. I feel significantly more effective”
                </p>
              </blockquote>
              <figcaption className="mt-6 text-base text-white">
                <div className="font-semibold">Benita Volkmann</div>
                <div className="mt-1">Solutions Manager</div>
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </div>

                <div className="py-16 bg-slate-200/50 overflow-hidden lg:py-24">
                    <div className="relative max-w-xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl">
                        <svg
                            className="hidden lg:block absolute  transform -translate-x-1/2 -translate-y-1/4"
                            width={404}
                            height={584}
                            fill="none"
                            viewBox="0 0 404 784"
                            aria-hidden="true"
                        >
                            <defs>
                                <pattern
                                    id="b1e6e422-73f8-40a6-b5d9-c8586e37e0e7"
                                    x={0}
                                    y={0}
                                    width={20}
                                    height={20}
                                    patternUnits="userSpaceOnUse"
                                >
                                    <rect x={0} y={0} width={4} height={4} className="text-gray-200" fill="currentColor" />
                                </pattern>
                            </defs>
                            <rect width={404} height={584} fill="url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)" />
                        </svg>

                        <div className="blur-3xl  ml-10  absolute h-32 w-32 -z-10 bg-fuchsia-400" />

                        <div className="relative" id="bookDemo">
                            <BurnoutQuiz 
                              query={"physicians"}
                            />
                        </div>
                        <div className="blur-3xl right-0 mr-48 absolute h-32 w-48 -z-10 bg-fuchsia-400" />

        
                    </div>

                </div>
                <section>
                <div className="bg-black- ">

          
      <div className="mx-auto max-w-7xl px-6 py-24 sm:py-20 my-24 relative lg:px-8 bg-fuchsia-100/70  rounded-2xl">
        <div className='-z-10 '>
        <svg
          className=" invisible sm:visible absolute mx-auto pt-30 right-0 -z-10 transform  "
          width={404}
          height={584}
          fill="none"
          viewBox="0 0 404 784"
          aria-hidden="true"
        >
          <defs>
            <pattern
              id="b1e6e422-73f8-40a6-b5d9-c8586e37e0e7"
              x={0}
              y={0}
              width={20}
              height={20}
              patternUnits="userSpaceOnUse"
            >
              <rect x={0} y={0} width={4} height={4} className="text-gray-300" fill="currentColor" />
            </pattern>
          </defs>
          <rect width={404} height={784} fill="url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)" />
        </svg>

        </div>
                   
        <div className="mx-auto max-w-4xl divide-y divide-gray-900/10">
          <h2 className="text-3xl font-extrabold text-slate-800 tracking-tight">Frequently asked questions</h2>
          <dl className="mt-10 space-y-6 divide-y divide-gray-900/10">
            {faqs.map((faq) => (
              <Disclosure as="div" key={faq.question} className="pt-6">
                {({ open }) => (
                  <>
                    <dt>
                      <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-600">
                        <span className="text-base font-semibold leading-7">{faq.question}</span>
                        <span className="ml-6 flex h-7 items-center">
                          {open ? (
                            <MinusSmIcon className="h-6 w-6" aria-hidden="true" />
                          ) : (
                            <PlusSmIcon className="h-6 w-6" aria-hidden="true" />
                          )}
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as="dd" className="mt-2 pr-12">
                      <p className="text-base leading-7 text-gray-800">{faq.answer}</p>
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>

                </section>

                <div className=''>

                    <br /> <br /> <br /> <br /> <br /> <br />
                    <p className="text-center">
                        <Link href="/terms-conditions" prefetch={false}>
                            <a > Terms & Conditions | </a>
                        </Link>
                        <Link href="/cookie-policy" prefetch={false}>
                            <a> Cookie Policy | </a>
                        </Link>
                        <Link href="/privacy-policy" prefetch={false} ><a>Privacy Policy</a></Link>
                    </p>
                    {/* <p className="text-center">
                    <Link href="/contact" passhref>
                    <Button variant="outline-purple" size="sm" className={footerStyles.no_sell_link}>Do Not Sell My Info</Button>
                    </Link>
                    </p> */}
                    <p className="text-center text-gray-400">© 2023 Ordinary Media, LLC. All Rights Reserved.</p>
                    </div>


            </main>

            <style jsx global>{`
         .img-cont > span {
          overflow:visible !important;
         }

         body {
            overlfow
         }

        `}</style>
        </div>



    )
}


const alertOptions = {
    // you can also just use 'bottom right'
    position: positions.BOTTOM_RIGHT,
    timeout: 3000,
    offset: '10px',
    containerStyle: { 'zIndex': '9999' },
    // you can also just use 'fade'
    transition: transitions.FADE,
}

Service.getLayout = function getLayout(page) {
    return (
        <AlertProvider template={AlertTemplate} {...alertOptions}>
            <AuthProvider>
                <Layout>
                    {page}
                </Layout>
            </AuthProvider>
        </AlertProvider>
    )
}


